export const APP_PLAY_SOUND = 'app_play_sound';
export const APP_SHOW_NOTIFICATION = 'app_show_notification';
export const AUDIO_PAUSE_ALL = 'audio_pause_all';
export const AUDIO_STOP_ALL = 'audio_stop_all';
export const CAROUSEL_HIDE = 'carousel_hide';
export const CAROUSEL_OPEN = 'carousel_open';
export const CHAT_BODY_SCROLL_TO_BOTTOM = 'chat_body_scroll_to_bottom';
export const CHAT_CHECK_FAILED_MESSAGES = 'chat_check_failed_messages';
export const CHAT_EMOJI_TOGGLE = 'chat_emoji_toggle';
export const CHAT_IMAGE_FROM_CLIPBOARD = 'chat_image_from_clipboard';
export const CHAT_INPUT_FOCUS = 'chat_input_focus';
export const CHAT_MULTIMEDIA_TOGGLE = 'chat_multimedia_toggle';
export const CHAT_SEND_MESSAGE = 'chat_send_message';
export const CHAT_SEND_MESSAGE_RETRY = 'chat_send_message_retry';
export const CONVERSATION_LOAD_HISTORY = 'conversation_load_history';
export const CONVERSATION_LOAD_MESSAGES = 'conversation_load_messages';
export const MESSAGES_LOADED = 'messages_loaded';
export const SHORTCUTS_MOVE_DOWN = 'shortcuts_move_down';
export const SHORTCUTS_MOVE_UP = 'shortcuts_move_up';
export const SHORTCUTS_SEARCH_TEXT = 'shortcuts_search_text';
export const SHORTCUTS_SELECT_INDEX = 'shortcuts_select_index';
export const SHORTCUTS_SELECT_TEXT = 'shortcuts_select_text';
export const SHORTCUTS_TOGGLE = 'shortcuts_toggle';
export const OPEN_USER_MENU = 'open-user-menu';
export const STATUS_USER = 'status-user';
export const USER_MULTIMEDIA_LOAD = 'user_multimedia_load';
export const USER_MULTIMEDIA_LOAD_STATUS = 'user_multimedia_status';
export const LOCALE_LAGUAGE_CHANGE = 'update_moment_locale';
